import React, { Component } from 'react';
import queryString from 'query-string';
import { withRouter } from 'react-router-dom';
import debounce from 'lodash/debounce';

import { restRequest } from '../../Helpers/RequestHelper';
import { SearchIcon } from '../../Assets/Mixed/SearchIcons';

import Dropdown from '../Dropdown/CustomDropdown';
import { routesPath } from '../../Pages/Navigation/NavigationUtils';
import OverlayLoader from '../Loader/OverlayLoader';

import './SearchBar.css';
import { t } from 'i18next';

class SearchBar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedFilter: 'contacts',
      selectedFilterLabel: t('Contacts.contacts'),
      onRealTimeSearch: false,
      isFocused: false,
      isFetching: false,
      contacts: [],
      showFilterStyles: null,
      searchFromIconValue: null,
      searchKeySelected: false,
      search:
        this.props.location.search.length > 0
          ? queryString.parse(this.props.location.search).search
          : '',
    };
  }
  //Mobile search expandable
  SearchbarHandler = () => {};
  filterOptions = [
    {
      id: 'contacts',
      label: t('Contacts.contacts'),
      path: routesPath.contacts,
      onClick: () =>
        this.setState({
          selectedFilter: 'contacts',
          selectedFilterLabel: t('Contacts.contacts'),
        }),
    },
    {
      id: 'items',
      label: t('Packages.items'),
      path: routesPath.items,
      onClick: () =>
        this.setState({
          selectedFilter: 'items',
          selectedFilterLabel: t('Packages.items'),
        }),
    },
    {
      id: 'item-groups',
      label: t('Items.item_group'),
      path: routesPath.itemGroups,
      onClick: () =>
        this.setState({
          selectedFilter: 'item-groups',
          selectedFilterLabel: t('Items.item_group'),
        }),
    },
    {
      id: 'item-adjustment',
      label: t('Items.item_adjustments'),
      path: routesPath.itemAdjustment,
      onClick: () =>
        this.setState({
          selectedFilter: 'item-adjustment',
          selectedFilterLabel: t('Items.item_adjustments'),
        }),
    },
    {
      id: 'salesorders',
      label: t('saleOrder.sales_order'),
      path: routesPath.salesOrders,
      onClick: () =>
        this.setState({
          selectedFilter: 'salesorders',
          selectedFilterLabel: t('saleOrder.sales_order'),
        }),
    },
    {
      id: 'packages',
      label: t('saleOrder.packages'),
      path: routesPath.packages,
      onClick: () =>
        this.setState({
          selectedFilter: 'packages',
          selectedFilterLabel: t('saleOrder.packages'),
        }),
    },
    {
      id: 'invoices',
      label: t('Invoice.title_secondary'),
      path: routesPath.invoices,
      onClick: () =>
        this.setState({
          selectedFilter: 'invoices',
          selectedFilterLabel: t('Invoice.title_secondary'),
        }),
    },
    {
      id: 'salesreturns',
      label: t('CreditNote.sales_return'),
      path: routesPath.salesreturns,
      onClick: () =>
        this.setState({
          selectedFilter: 'salesreturns',
          selectedFilterLabel: t('CreditNote.sales_return'),
        }),
    },
    {
      id: 'creditnotes',
      label: t('CreditNote.cn'),
      path: routesPath.creditnotes,
      onClick: () =>
        this.setState({
          selectedFilter: 'creditnotes',
          selectedFilterLabel: t('CreditNote.cn'),
        }),
    },
    {
      id: 'paymentsmade',
      label: t('Payments.payments_received'),
      path: routesPath.customerPayment,
      onClick: () =>
        this.setState({
          selectedFilter: 'paymentsmade',
          selectedFilterLabel: t('Payments.payments_received'),
        }),
    },
    {
      id: 'purchaseorders',
      label: t('Items.purchase_orders'),
      path: routesPath.purchaseOrders,
      onClick: () =>
        this.setState({
          selectedFilter: 'purchaseorders',
          selectedFilterLabel: t('Items.purchase_orders'),
        }),
    },
    {
      id: 'bills',
      label: t('bill.bills'),
      path: routesPath.bills,
      onClick: () =>
        this.setState({
          selectedFilter: 'bills',
          selectedFilterLabel: t('bill.bills'),
        }),
    },
    {
      id: 'account',
      label: t('bill.charts_of_accounts'),
      path: routesPath.chartOfAccount,
      onClick: () =>
        this.setState({
          selectedFilter: 'account',
          selectedFilterLabel: t('bill.charts_of_accounts'),
        }),
    },
  ];

  componentDidMount() {
    if (this.state.search && this.state.search.length > 0) {
      this.setState({ searchKeySelected: true });
    } else {
      this.setState({ searchKeySelected: false });
    }

    this.checkPaths();
    document.addEventListener('mousedown', this.handleResultOutsideClick);
  }

  componentDidUpdate(prevProps) {
    if (
      this.state.search &&
      this.state.search.length > 0 &&
      this.state.searchKeySelected === true
    ) {
      this.input.focus();
    }
    if (this.props.location.pathname !== prevProps.location.pathname) {
      this.setState({ searchKeySelected: false });
      this.input.blur();
      this.checkPaths();
    }
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleResultOutsideClick);
  }

  checkPaths() {
    const filterIds = this.filterOptions;
    if (
      this.props.location.pathname.includes(this.state.selectedFilter) === false
    ) {
      this.input.value = '';
    }
    let validFilterPath = false;
    for (let filter of filterIds) {
      if (
        this.props.location.pathname.includes(filter.id) &&
        this.props.location.pathname !== '/packagesplan'
      ) {
        this.setState({ selectedFilter: filter.id });
        this.setState({ selectedFilterLabel: filter.label });
        validFilterPath = true;
      }
    }
    if (!validFilterPath) {
      this.setState({ selectedFilter: 'contacts' });
      this.setState({ selectedFilterLabel: t('Contacts.contacts') });
    }
  }

  inputOnFocus = (event) => {
    this.setState({ isFocused: true });
    this.handleRealTimeSearch(event.target.value);
  };

  inputOnBlur = () => {
    // this.setState({ isFocused: false, contacts: [], onRealTimeSearch: false })
    this.setState({ isFocused: false });
  };

  inputOnChange = (event) => {
    this.handleRealTimeSearch(event.target.value);
    this.setState({ searchFromIconValue: event.target.value });
  };

  handleRealTimeSearch(value) {
    if (this.state.selectedFilter !== 'contacts') return;

    if (value === '') {
      this.setState({ contacts: [], onRealTimeSearch: false });
    } else {
      this.setState({ onRealTimeSearch: true, isFetching: true });
      this.handleInputChange(value);
    }
  }

  handleInputChange = debounce(async (value) => {
    let val = value.replace('&', '%26');
    const res = await restRequest(
      'get',
      `contacts?search=${val}&page=1&view=5`
    );
    if (this.state.onRealTimeSearch) {
      this.setState({
        contacts: res.contacts.data,
        isFetching: false,
      });
    }
  }, 500);

  handleSearchSubmit = (event, fromIcon = false) => {
    if (this.input.value === '') {
      event.preventDefault();
      this.input.focus();
      return;
    } else {
      event.preventDefault();
      const searchKey = fromIcon
        ? this.state.searchFromIconValue
        : this.input.value;
      if (!searchKey) return;
      const searchPath = this.filterOptions.find((filter) => {
        return filter.id === this.state.selectedFilter;
      }).path;

      this.input.value = '';
      this.input.blur();

      this.setState({ contacts: [], onRealTimeSearch: false });
      if (searchKey) {
        this.setState({ search: searchKey });
        this.setState({ searchKeySelected: true });
      } else {
        this.setState({ search: '' });
        this.setState({ searchKeySelected: false });
      }
      const pos = searchKey.indexOf('&');
      var newSearchKey = searchKey;
      if (pos !== -1) {
        newSearchKey = searchKey.replace(/&/g, '%26');
      }
      newSearchKey = newSearchKey.replace('&', '%26');
      this.props.history.push(
        `${searchPath}?search=${encodeURIComponent(newSearchKey)}`
      );
    }
  };

  handleResultOutsideClick = (event) => {
    this.setState({ search: '' });
    if (this.searchResult && !this.searchResult.contains(event.target)) {
      this.setState({ contacts: [], onRealTimeSearch: false });
    }
  };
  showFilter(val) {
    this.setState({
      showFilterStyles: val,
    });
  }
  renderFilter() {
    return (
      <span
        className={`search-bar--dropdown search_header_filter ${
          this.state.selectedFilterLabel === t('Items.purchase_orders') ||
          this.state.selectedFilterLabel === t('Items.item_adjustments') ||
          this.state.selectedFilterLabel === t('Payments.payments_received')
            ? 'added_search'
            : ''
        }`}
      >
        <Dropdown
          selectedFilter={this.state.selectedFilter}
          textLabel={this.state.selectedFilterLabel}
          showFilterFlag={true}
          showFilter={this.showFilter.bind(this)}
          options={this.filterOptions}
        />
      </span>
    );
  }

  handleResultClick(id) {
    this.setState({ contacts: [], onRealTimeSearch: false });
    this.props.history.push(`/contacts/${id}`);
  }

  renderSearchResult() {
    const { isFetching, contacts } = this.state;
    return (
      <div
        className="search-holder--search-result"
        ref={(element) => {
          this.searchResult = element;
        }}
      >
        {isFetching && <OverlayLoader />}
        {contacts.map((contact) => (
          <li
            key={contact.id}
            onClick={() => this.handleResultClick(contact.id)}
          >
            <div>{contact.display_name}</div>
            <div className="grey font-1_2rem">{contact.company_name}</div>
            <div className="grey font-1_2rem">{contact.email}</div>
          </li>
        ))}
        {!contacts.length && !isFetching && (
          <li className="no-result"> {t('common.no_result')} </li>
        )}
      </div>
    );
  }

  render() {
    return (
      <div className="search-holder mob-searchbar">
        <div
          className={`search-bar ${
            this.state.showFilterStyles ? 'search-head' : ''
          } ${this.state.isFocused ? 'focus' : ''}`}
        >
          {this.renderFilter()}
          <form onSubmit={this.handleSearchSubmit}>
            <input
              ref={(element) => {
                this.input = element;
              }}
              onFocus={this.inputOnFocus}
              onBlur={this.inputOnBlur}
              onChange={this.inputOnChange}
              className="search-bar--input"
              type="text"
              placeholder={t('common.search')}
              maxLength="100"
              id="realTimeSearch"
            />
            <div
              title={t('common.search')}
              className="pointer"
              onClick={(e) => this.handleSearchSubmit(e, true)}
            >
              <SearchIcon onClick={this.SearchbarHandler()} />
            </div>
          </form>
        </div>
        {this.state.onRealTimeSearch && this.renderSearchResult()}
      </div>
    );
  }
}

export default withRouter(SearchBar);
